(() => {
  'use strict';
  const form=document.getElementById('reservation-form');
  if(!form)return;
  const endpoint=document.querySelector('meta[name="rozz-api"]').content.replace(/\/$/,'');
  const status=document.getElementById('reservation-status'), result=document.getElementById('reservation-result');
  const button=form.querySelector('button[type="submit"]');
  let pending=false,finished=false,started=false,requestId=crypto.randomUUID();
  const eventId=crypto.randomUUID();
  function track(event){fetch(endpoint+'/api/events',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({event,eventId}),keepalive:true}).catch(()=>{});}
  function start(){if(!started){started=true;track('reservation_start');}}
  track('page_view');
  function update(){
    const n=Number(form.elements.quantity.value)||1;
    const price=form.elements.flavour.value==='chocolate'?69:59;
    document.getElementById('reservation-total').textContent='₹'+(n*price).toLocaleString('en-IN');
    document.getElementById('reservation-count').textContent=n+' bottle'+(n===1?'':'s')+' × ₹'+price;
  }
  form.addEventListener('focusin',start,{once:true});
  form.addEventListener('input',e=>{e.target.setCustomValidity?.('');e.target.removeAttribute('aria-invalid');status.textContent='';update();});
  form.addEventListener('change',update);
  document.querySelectorAll('[data-order-flavour]').forEach(a=>a.addEventListener('click',()=>{
    if(!finished&&!pending){form.elements.flavour.value=a.dataset.orderFlavour;start();update();}
  }));
  form.addEventListener('submit',async e=>{
    e.preventDefault();if(pending||finished)return;
    const fields=form.elements;
    fields.name.setCustomValidity(fields.name.value.trim().length>=2?'':'Please enter your name.');
    if(!form.reportValidity())return;
    start();pending=true;button.disabled=true;button.textContent='Saving your reservation…';status.textContent='';
    const body={name:fields.name.value,phone:fields.phone.value,pin:fields.pin.value,flavour:fields.flavour.value,quantity:Number(fields.quantity.value),reservationConsent:fields.reservationConsent.checked,marketingConsent:fields.marketingConsent.checked,website:fields.website.value,requestId};
    const controls=[...form.querySelectorAll('input,select')];controls.forEach(el=>el.disabled=true);
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    try{
      const response=await fetch(endpoint+'/api/reservations',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:controller.signal});
      const data=await response.json();
      if(!response.ok){
        Object.entries(data.fields||{}).forEach(([key,value])=>{const f=fields.namedItem(key);if(f&&f.setCustomValidity){f.setCustomValidity(value);f.setAttribute('aria-invalid','true');}});
        throw new Error(data.error||'We could not confirm your reservation. Please try again.');
      }
      if(!/^RZ-[A-F0-9]{12}$/.test(data.reference))throw new Error('We could not confirm your reservation. Please try again.');
      finished=true;
      document.getElementById('reservation-reference').textContent=data.reference;
      document.getElementById('reservation-result-heading').textContent=data.duplicate?'Your reservation is already saved.':'Your ROZZ reservation is saved.';
      const price=body.flavour==='chocolate'?69:59;
      const message=['Hi ROZZ! I would like to pre-order.','Reservation: '+data.reference,'Name: '+body.name.trim(),'WhatsApp: '+body.phone,'Delivery PIN: '+body.pin,'Flavour: '+(body.flavour==='chocolate'?'Chocolate':'Shikanji'),'Bottles: '+body.quantity,'Price: ₹'+price+' per bottle','Product total: ₹'+(body.quantity*price),'Please confirm availability, delivery charges and the final order before sharing payment details.'].join('\n');
      document.getElementById('reservation-whatsapp').href='https://wa.me/917078893043?text='+encodeURIComponent(message);
      result.hidden=false;form.hidden=true;result.focus();
      // Success is counted from persisted server records, never a client-side optimistic event.
    }catch(error){
      status.textContent=error.name==='AbortError'?'We could not confirm the result yet. Please retry; if it was saved, you will get the same reference.':error.message;
      status.focus();
    }finally{
      clearTimeout(timer);pending=false;
      if(!finished){controls.forEach(el=>el.disabled=false);button.disabled=false;button.textContent='Reserve my ROZZ';}
    }
  });
  update();
})();
